import { IconInfo } from './IconInfo'

export default IconInfo
